"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignalGroupRegistry = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
class SignalGroupRegistry {
    static { this.NAMED_MEMBERS = 3; }
    constructor(existing, signals) {
        this.signals = signals;
        this.groups = existing.map((group) => ({ ...group, signalIds: [...group.signalIds] }));
    }
    groupFor(signalIds) {
        const members = [...new Set(signalIds)].sort();
        const key = members.join(',');
        const existing = this.groups.find((group) => [...group.signalIds].sort().join(',') === key);
        if (existing !== undefined) {
            return existing.id;
        }
        const id = `grp_${sigma_engine_shared_1.Utils.fnv1aHash(key)}`;
        this.groups.push({ id, name: this.nameFor(members), signalIds: members });
        return id;
    }
    all() {
        return this.groups.map((group) => ({ ...group, signalIds: [...group.signalIds] }));
    }
    nameFor(members) {
        const names = members.map((id) => this.signals.find((signal) => String(signal.id) === id)?.name ?? id);
        const shown = names.slice(0, SignalGroupRegistry.NAMED_MEMBERS).join(', ');
        const rest = names.length - SignalGroupRegistry.NAMED_MEMBERS;
        return rest > 0 ? `${shown} +${rest}` : shown;
    }
}
exports.SignalGroupRegistry = SignalGroupRegistry;
//# sourceMappingURL=signal-group-registry.js.map